import { Component, h, Prop } from '@stencil/core'
import { SearchResultItem } from '../../../../domain/models/search'

@Component({
  tag: 'cr-facilities-bucket',
  styleUrl: 'cr-facilities-bucket.css',
  shadow: true,
})
export class CrFacilitiesBucket {

  @Prop() facilityDiscoveries: Array<SearchResultItem> = []

  render() {
    return (this.facilityDiscoveries.map((discovery) =>
      <div class="professional-result">
        { `${discovery.displayName}` }
      </div>
    ))
  }

}
